import { styled } from 'linaria/react';

const stockColors = {
  inStock: '#21A72E',
  outOfStock: '#EB5757',
  notifyWhenBack: '#F2C94C',
  inComing: '#ffb000'
};

const StockOrb = styled('span')`
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  transition: all 0.2s linear;
  background-color: ${({ status }) => stockColors[status]};
  border: 1px solid transparent;
  &.inStock {
    background-color: ${stockColors['inStock']};
  }
  &.outOfStock {
    background-color: ${stockColors['outOfStock']};
  }
  &.notifyWhenBack {
    background-color: ${stockColors['notifyWhenBack']};
  }
  &.missingVariant {
    background-color: transparent;
    border-color: ${stockColors['outOfStock']};
  }
`;

export default StockOrb;
